export const MANUALS = [
    {
        language: "en-US",
        label: "English",
        url: "https://app.notion.com/p/RetailTrend-Manager-User-s-Guide-3aba9e121b97805580a0dec6c259b065",
    },
    {
        language: "ko-KR",
        label: "한국어",
        url: "https://app.notion.com/p/3aba9e121b978064acd8d9e13535a5e3",
    },
];
